export default __webpack_public_path__ + "static/media/thumbnail.5c2fafd0.png";